import { ArrowUpRight } from "lucide-react";
import Artwork from "./Artwork";
import { Reveal, Eyebrow } from "./Reveal";
import { CONTENT } from "@/content";

export default function LatestRelease() {
  const r = CONTENT.latestRelease;
  return (
    <section id="music" data-testid="music-section" className="relative py-28 md:py-44 px-6 md:px-16 max-w-[1600px] mx-auto">
      <Reveal>
        <Eyebrow data-testid="latest-release-eyebrow">{r.eyebrow || `LATEST RELEASE — ${r.type}`}</Eyebrow>
      </Reveal>

      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center mt-10 lg:mt-14">
        <Reveal className="lg:col-span-7">
          <div data-testid="latest-release-artwork" className="relative group max-w-[560px] mx-auto lg:max-w-none">
            <div className="absolute -inset-6 bg-[#38bdf8]/8 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-1000" />
            <Artwork
              variant={r.variant}
              image={r.image}
              alt={`${r.title} — Cover Artwork`}
              glow
              className="relative aspect-square w-full transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.02]"
            />
            <div className="absolute -bottom-px left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#38bdf8]/60 to-transparent" />
          </div>
        </Reveal>

        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-[6.5vw] sm:text-4xl lg:text-3xl xl:text-4xl 2xl:text-5xl text-[#f5f3ef]">
              {r.title}
            </h2>
            <p className="font-mono2 text-[11px] tracking-[0.35em] text-[#38bdf8] mt-5 uppercase">
              {r.subtitle || `${r.type} · ${r.date}`}
            </p>
            <p className="mt-6 text-sm md:text-base text-[#a3a3ac] font-light leading-relaxed max-w-md">
              {r.description}
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-10 border-t border-white/10">
              {(r.links || CONTENT.streaming).map((s) => (
                <a
                  key={s.name}
                  data-testid={`latest-release-link-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-between py-4 border-b border-white/10 font-mono2 text-xs tracking-[0.3em] text-[#a3a3ac] hover:text-[#70c7fa] transition-colors duration-300"
                >
                  {s.name}
                  <ArrowUpRight className="w-4 h-4 opacity-40 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
